import e, { memo as a, useState as i, useRef as s, useEffect as o, useCallback as r } from "react";
import n from "classnames";
import d from "react-country-flag";
import t from "lodash.omit";
import { parsePhoneNumberFromString as C } from "libphonenumber-js";

function m(e, a, i) {
  return a in e ? Object.defineProperty(e, a, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[a] = i, e;
}

function c(e, a) {
  var i = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    a && (s = s.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), i.push.apply(i, s);
  }

  return i;
}

function A(e) {
  for (var a = 1; a < arguments.length; a++) {
    var i = null != arguments[a] ? arguments[a] : {};
    a % 2 ? c(Object(i), !0).forEach(function (a) {
      m(e, a, i[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : c(Object(i)).forEach(function (a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(i, a));
    });
  }

  return e;
}

function h(e, a) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, a) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
      var i = [],
          s = !0,
          o = !1,
          r = void 0;

      try {
        for (var n, d = e[Symbol.iterator](); !(s = (n = d.next()).done) && (i.push(n.value), !a || i.length !== a); s = !0) {
          ;
        }
      } catch (e) {
        o = !0, r = e;
      } finally {
        try {
          s || null == d.return || d.return();
        } finally {
          if (o) throw r;
        }
      }

      return i;
    }
  }(e, a) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}

var l = "undefined" != typeof window,
    u = {
  Android: function Android() {
    return l && window.navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function BlackBerry() {
    return l && window.navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function iOS() {
    return l && window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function Opera() {
    return l && window.navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function Windows() {
    return l && window.navigator.userAgent.match(/IEMobile/i);
  },
  any: function any() {
    return u.Android() || u.BlackBerry() || u.iOS() || u.Opera() || u.Windows();
  }
},
    g = [{
  name: "International",
  regions: [],
  iso2: "intl",
  dialCode: "",
  isAreaCode: !0,
  hasAreaCodes: !1
}, {
  name: "Afghanistan (‫افغانستان‬‎)",
  regions: ["asia"],
  iso2: "af",
  dialCode: "+93",
  hasAreaCodes: !1
}, {
  name: "Albania (Shqipëri)",
  regions: ["europe"],
  iso2: "al",
  dialCode: "+355",
  hasAreaCodes: !1
}, {
  name: "Algeria (‫الجزائر‬‎)",
  regions: ["africa", "north-africa"],
  iso2: "dz",
  dialCode: "+213",
  hasAreaCodes: !1
}, {
  name: "American Samoa",
  regions: ["oceania"],
  iso2: "as",
  dialCode: "+1684",
  hasAreaCodes: !1
}, {
  name: "Andorra",
  regions: ["europe"],
  iso2: "ad",
  dialCode: "+376",
  hasAreaCodes: !1
}, {
  name: "Angola",
  regions: ["africa"],
  iso2: "ao",
  dialCode: "+244",
  hasAreaCodes: !1
}, {
  name: "Anguilla",
  regions: ["america", "carribean"],
  iso2: "ai",
  dialCode: "+1264",
  hasAreaCodes: !1
}, {
  name: "Antigua and Barbuda",
  regions: ["america", "carribean"],
  iso2: "ag",
  dialCode: "+1268",
  hasAreaCodes: !1
}, {
  name: "Argentina",
  regions: ["america", "south-america"],
  iso2: "ar",
  dialCode: "+54",
  hasAreaCodes: !1
}, {
  name: "Armenia (Հայաստան)",
  regions: ["asia", "ex-ussr"],
  iso2: "am",
  dialCode: "+374",
  hasAreaCodes: !1
}, {
  name: "Aruba",
  regions: ["america", "carribean"],
  iso2: "aw",
  dialCode: "+297",
  hasAreaCodes: !1
}, {
  name: "Australia",
  regions: ["oceania"],
  iso2: "au",
  dialCode: "+61",
  hasAreaCodes: !1
}, {
  name: "Austria (Österreich)",
  regions: ["europe", "european-union"],
  iso2: "at",
  dialCode: "+43",
  hasAreaCodes: !1
}, {
  name: "Azerbaijan (Azərbaycan)",
  regions: ["asia", "ex-ussr"],
  iso2: "az",
  dialCode: "+994",
  hasAreaCodes: !1
}, {
  name: "Bahamas",
  regions: ["america", "carribean"],
  iso2: "bs",
  dialCode: "+1242",
  hasAreaCodes: !1
}, {
  name: "Bahrain (‫البحرين‬‎)",
  regions: ["middle-east"],
  iso2: "bh",
  dialCode: "+973",
  hasAreaCodes: !1
}, {
  name: "Bangladesh (বাংলাদেশ)",
  regions: ["asia"],
  iso2: "bd",
  dialCode: "+880",
  hasAreaCodes: !1
}, {
  name: "Barbados",
  regions: ["america", "carribean"],
  iso2: "bb",
  dialCode: "+1246",
  hasAreaCodes: !1
}, {
  name: "Belarus (Беларусь)",
  regions: ["europe", "ex-ussr"],
  iso2: "by",
  dialCode: "+375",
  hasAreaCodes: !1
}, {
  name: "Belgium (België)",
  regions: ["europe", "european-union"],
  iso2: "be",
  dialCode: "+32",
  hasAreaCodes: !1
}, {
  name: "Belize",
  regions: ["america", "central-america"],
  iso2: "bz",
  dialCode: "+501",
  hasAreaCodes: !1
}, {
  name: "Benin (Bénin)",
  regions: ["africa"],
  iso2: "bj",
  dialCode: "+229",
  hasAreaCodes: !1
}, {
  name: "Bermuda",
  regions: ["america", "north-america"],
  iso2: "bm",
  dialCode: "+1441",
  hasAreaCodes: !1
}, {
  name: "Bhutan (འབྲུག)",
  regions: ["asia"],
  iso2: "bt",
  dialCode: "+975",
  hasAreaCodes: !1
}, {
  name: "Bolivia",
  regions: ["america", "south-america"],
  iso2: "bo",
  dialCode: "+591",
  hasAreaCodes: !1
}, {
  name: "Bosnia and Herzegovina (Босна и Херцеговина)",
  regions: ["europe"],
  iso2: "ba",
  dialCode: "+387",
  hasAreaCodes: !1
}, {
  name: "Botswana",
  regions: ["africa"],
  iso2: "bw",
  dialCode: "+267",
  hasAreaCodes: !1
}, {
  name: "Brazil (Brasil)",
  regions: ["america", "south-america"],
  iso2: "br",
  dialCode: "+55",
  hasAreaCodes: !1
}, {
  name: "British Indian Ocean Territory",
  regions: ["asia"],
  iso2: "io",
  dialCode: "+246",
  hasAreaCodes: !1
}, {
  name: "British Virgin Islands",
  regions: ["america", "carribean"],
  iso2: "vg",
  dialCode: "+1284",
  hasAreaCodes: !1
}, {
  name: "Brunei",
  regions: ["asia"],
  iso2: "bn",
  dialCode: "+673",
  hasAreaCodes: !1
}, {
  name: "Bulgaria (България)",
  regions: ["europe", "european-union"],
  iso2: "bg",
  dialCode: "+359",
  hasAreaCodes: !1
}, {
  name: "Burkina Faso",
  regions: ["africa"],
  iso2: "bf",
  dialCode: "+226",
  hasAreaCodes: !1
}, {
  name: "Burundi (Uburundi)",
  regions: ["africa"],
  iso2: "bi",
  dialCode: "+257",
  hasAreaCodes: !1
}, {
  name: "Cambodia (កម្ពុជា)",
  regions: ["asia"],
  iso2: "kh",
  dialCode: "+855",
  hasAreaCodes: !1
}, {
  name: "Cameroon (Cameroun)",
  regions: ["africa"],
  iso2: "cm",
  dialCode: "+237",
  hasAreaCodes: !1
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1",
  hasAreaCodes: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1204",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1236",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1249",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1250",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1289",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1306",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1343",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1365",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1387",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1403",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1416",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1418",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1431",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1437",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1438",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1450",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1506",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1514",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1519",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1548",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1579",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1581",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1587",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1604",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1613",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1639",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1647",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1672",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1705",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1709",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1742",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1778",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1780",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1782",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1807",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1819",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1825",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1867",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1873",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1902",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Canada",
  regions: ["america", "north-america"],
  iso2: "ca",
  dialCode: "+1905",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Cape Verde (Kabu Verdi)",
  regions: ["africa"],
  iso2: "cv",
  dialCode: "+238",
  hasAreaCodes: !1
}, {
  name: "Caribbean Netherlands",
  regions: ["america", "carribean"],
  iso2: "bq",
  dialCode: "+599",
  hasAreaCodes: !1
}, {
  name: "Cayman Islands",
  regions: ["america", "carribean"],
  iso2: "ky",
  dialCode: "+1345",
  hasAreaCodes: !1
}, {
  name: "Central African Republic (République centrafricaine)",
  regions: ["africa"],
  iso2: "cf",
  dialCode: "+236",
  hasAreaCodes: !1
}, {
  name: "Chad (Tchad)",
  regions: ["africa"],
  iso2: "td",
  dialCode: "+235",
  hasAreaCodes: !1
}, {
  name: "Chile",
  regions: ["america", "south-america"],
  iso2: "cl",
  dialCode: "+56",
  hasAreaCodes: !1
}, {
  name: "China (中国)",
  regions: ["asia"],
  iso2: "cn",
  dialCode: "+86",
  hasAreaCodes: !1
}, {
  name: "Colombia",
  regions: ["america", "south-america"],
  iso2: "co",
  dialCode: "+57",
  hasAreaCodes: !1
}, {
  name: "Comoros (‫جزر القمر‬‎)",
  regions: ["africa"],
  iso2: "km",
  dialCode: "+269",
  hasAreaCodes: !1
}, {
  name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
  regions: ["africa"],
  iso2: "cd",
  dialCode: "+243",
  hasAreaCodes: !1
}, {
  name: "Congo (Republic) (Congo-Brazzaville)",
  regions: ["africa"],
  iso2: "cg",
  dialCode: "+242",
  hasAreaCodes: !1
}, {
  name: "Cook Islands",
  regions: ["oceania"],
  iso2: "ck",
  dialCode: "+682",
  hasAreaCodes: !1
}, {
  name: "Costa Rica",
  regions: ["america", "central-america"],
  iso2: "cr",
  dialCode: "+506",
  hasAreaCodes: !1
}, {
  name: "Côte d’Ivoire",
  regions: ["africa"],
  iso2: "ci",
  dialCode: "+225",
  hasAreaCodes: !1
}, {
  name: "Croatia (Hrvatska)",
  regions: ["europe", "european-union"],
  iso2: "hr",
  dialCode: "+385",
  hasAreaCodes: !1
}, {
  name: "Cuba",
  regions: ["america", "carribean"],
  iso2: "cu",
  dialCode: "+53",
  hasAreaCodes: !1
}, {
  name: "Curaçao",
  regions: ["america", "carribean"],
  iso2: "cw",
  dialCode: "+599",
  hasAreaCodes: !1
}, {
  name: "Cyprus (Κύπρος)",
  regions: ["europe", "european-union"],
  iso2: "cy",
  dialCode: "+357",
  hasAreaCodes: !1
}, {
  name: "Czech Republic (Česká republika)",
  regions: ["europe", "european-union"],
  iso2: "cz",
  dialCode: "+420",
  hasAreaCodes: !1
}, {
  name: "Denmark (Danmark)",
  regions: ["europe", "european-union"],
  iso2: "dk",
  dialCode: "+45",
  hasAreaCodes: !1
}, {
  name: "Djibouti",
  regions: ["africa"],
  iso2: "dj",
  dialCode: "+253",
  hasAreaCodes: !1
}, {
  name: "Dominica",
  regions: ["america", "carribean"],
  iso2: "dm",
  dialCode: "+1767",
  hasAreaCodes: !1
}, {
  name: "Dominican Republic (República Dominicana)",
  regions: ["america", "carribean"],
  iso2: "do",
  dialCode: "+1",
  hasAreaCodes: !0
}, {
  name: "Dominican Republic (República Dominicana)",
  regions: ["america", "carribean"],
  iso2: "do",
  dialCode: "+1809",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Dominican Republic (República Dominicana)",
  regions: ["america", "carribean"],
  iso2: "do",
  dialCode: "+1829",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Dominican Republic (República Dominicana)",
  regions: ["america", "carribean"],
  iso2: "do",
  dialCode: "+1849",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Ecuador",
  regions: ["america", "south-america"],
  iso2: "ec",
  dialCode: "+593",
  hasAreaCodes: !1
}, {
  name: "Egypt (‫مصر‬‎)",
  regions: ["africa", "north-africa"],
  iso2: "eg",
  dialCode: "+20",
  hasAreaCodes: !1
}, {
  name: "El Salvador",
  regions: ["america", "central-america"],
  iso2: "sv",
  dialCode: "+503",
  hasAreaCodes: !1
}, {
  name: "Equatorial Guinea (Guinea Ecuatorial)",
  regions: ["africa"],
  iso2: "gq",
  dialCode: "+240",
  hasAreaCodes: !1
}, {
  name: "Eritrea",
  regions: ["africa"],
  iso2: "er",
  dialCode: "+291",
  hasAreaCodes: !1
}, {
  name: "Estonia (Eesti)",
  regions: ["europe", "european-union", "ex-ussr"],
  iso2: "ee",
  dialCode: "+372",
  hasAreaCodes: !1
}, {
  name: "Ethiopia",
  regions: ["africa"],
  iso2: "et",
  dialCode: "+251",
  hasAreaCodes: !1
}, {
  name: "Falkland Islands (Islas Malvinas)",
  regions: ["america", "south-america"],
  iso2: "fk",
  dialCode: "+500",
  hasAreaCodes: !1
}, {
  name: "Faroe Islands (Føroyar)",
  regions: ["europe"],
  iso2: "fo",
  dialCode: "+298",
  hasAreaCodes: !1
}, {
  name: "Fiji",
  regions: ["oceania"],
  iso2: "fj",
  dialCode: "+679",
  hasAreaCodes: !1
}, {
  name: "Finland (Suomi)",
  regions: ["europe", "european-union"],
  iso2: "fi",
  dialCode: "+358",
  hasAreaCodes: !1
}, {
  name: "France",
  regions: ["europe", "european-union"],
  iso2: "fr",
  dialCode: "+33",
  hasAreaCodes: !1
}, {
  name: "French Guiana (Guyane française)",
  regions: ["america", "south-america"],
  iso2: "gf",
  dialCode: "+594",
  hasAreaCodes: !1
}, {
  name: "French Polynesia (Polynésie française)",
  regions: ["oceania"],
  iso2: "pf",
  dialCode: "+689",
  hasAreaCodes: !1
}, {
  name: "Gabon",
  regions: ["africa"],
  iso2: "ga",
  dialCode: "+241",
  hasAreaCodes: !1
}, {
  name: "Gambia",
  regions: ["africa"],
  iso2: "gm",
  dialCode: "+220",
  hasAreaCodes: !1
}, {
  name: "Georgia (საქართველო)",
  regions: ["asia", "ex-ussr"],
  iso2: "ge",
  dialCode: "+995",
  hasAreaCodes: !1
}, {
  name: "Germany (Deutschland)",
  regions: ["europe", "european-union"],
  iso2: "de",
  dialCode: "+49",
  hasAreaCodes: !1
}, {
  name: "Ghana (Gaana)",
  regions: ["africa"],
  iso2: "gh",
  dialCode: "+233",
  hasAreaCodes: !1
}, {
  name: "Gibraltar",
  regions: ["europe"],
  iso2: "gi",
  dialCode: "+350",
  hasAreaCodes: !1
}, {
  name: "Greece (Ελλάδα)",
  regions: ["europe", "european-union"],
  iso2: "gr",
  dialCode: "+30",
  hasAreaCodes: !1
}, {
  name: "Greenland (Kalaallit Nunaat)",
  regions: ["america"],
  iso2: "gl",
  dialCode: "+299",
  hasAreaCodes: !1
}, {
  name: "Grenada",
  regions: ["america", "carribean"],
  iso2: "gd",
  dialCode: "+1473",
  hasAreaCodes: !1
}, {
  name: "Guadeloupe",
  regions: ["america", "carribean"],
  iso2: "gp",
  dialCode: "+590",
  hasAreaCodes: !1
}, {
  name: "Guam",
  regions: ["oceania"],
  iso2: "gu",
  dialCode: "+1671",
  hasAreaCodes: !1
}, {
  name: "Guatemala",
  regions: ["america", "central-america"],
  iso2: "gt",
  dialCode: "+502",
  hasAreaCodes: !1
}, {
  name: "Guinea (Guinée)",
  regions: ["africa"],
  iso2: "gn",
  dialCode: "+224",
  hasAreaCodes: !1
}, {
  name: "Guinea-Bissau (Guiné Bissau)",
  regions: ["africa"],
  iso2: "gw",
  dialCode: "+245",
  hasAreaCodes: !1
}, {
  name: "Guyana",
  regions: ["america", "south-america"],
  iso2: "gy",
  dialCode: "+592",
  hasAreaCodes: !1
}, {
  name: "Haiti",
  regions: ["america", "carribean"],
  iso2: "ht",
  dialCode: "+509",
  hasAreaCodes: !1
}, {
  name: "Honduras",
  regions: ["america", "central-america"],
  iso2: "hn",
  dialCode: "+504",
  hasAreaCodes: !1
}, {
  name: "Hong Kong (香港)",
  regions: ["asia"],
  iso2: "hk",
  dialCode: "+852",
  hasAreaCodes: !1
}, {
  name: "Hungary (Magyarország)",
  regions: ["europe", "european-union"],
  iso2: "hu",
  dialCode: "+36",
  hasAreaCodes: !1
}, {
  name: "Iceland (Ísland)",
  regions: ["europe"],
  iso2: "is",
  dialCode: "+354",
  hasAreaCodes: !1
}, {
  name: "India (भारत)",
  regions: ["asia"],
  iso2: "in",
  dialCode: "+91",
  hasAreaCodes: !1
}, {
  name: "Indonesia",
  regions: ["asia"],
  iso2: "id",
  dialCode: "+62",
  hasAreaCodes: !1
}, {
  name: "Iran (‫ایران‬‎)",
  regions: ["middle-east"],
  iso2: "ir",
  dialCode: "+98",
  hasAreaCodes: !1
}, {
  name: "Iraq (‫العراق‬‎)",
  regions: ["middle-east"],
  iso2: "iq",
  dialCode: "+964",
  hasAreaCodes: !1
}, {
  name: "Ireland",
  regions: ["europe", "european-union"],
  iso2: "ie",
  dialCode: "+353",
  hasAreaCodes: !1
}, {
  name: "Israel (‫ישראל‬‎)",
  regions: ["middle-east"],
  iso2: "il",
  dialCode: "+972",
  hasAreaCodes: !1
}, {
  name: "Italy (Italia)",
  regions: ["europe", "european-union"],
  iso2: "it",
  dialCode: "+39",
  hasAreaCodes: !1
}, {
  name: "Jamaica",
  regions: ["america", "carribean"],
  iso2: "jm",
  dialCode: "+1876",
  hasAreaCodes: !1
}, {
  name: "Japan (日本)",
  regions: ["asia"],
  iso2: "jp",
  dialCode: "+81",
  hasAreaCodes: !1
}, {
  name: "Jordan (‫الأردن‬‎)",
  regions: ["middle-east"],
  iso2: "jo",
  dialCode: "+962",
  hasAreaCodes: !1
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7",
  hasAreaCodes: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7313",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7327",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+77172",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7312",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+773622",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7321",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7324",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7336",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7318",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7315",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7325",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7311",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7326",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kazakhstan (Казахстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kz",
  dialCode: "+7310",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Kenya",
  regions: ["africa"],
  iso2: "ke",
  dialCode: "+254",
  hasAreaCodes: !1
}, {
  name: "Kiribati",
  regions: ["oceania"],
  iso2: "ki",
  dialCode: "+686",
  hasAreaCodes: !1
}, {
  name: "Kuwait (‫الكويت‬‎)",
  regions: ["middle-east"],
  iso2: "kw",
  dialCode: "+965",
  hasAreaCodes: !1
}, {
  name: "Kyrgyzstan (Кыргызстан)",
  regions: ["asia", "ex-ussr"],
  iso2: "kg",
  dialCode: "+996",
  hasAreaCodes: !1
}, {
  name: "Laos (ລາວ)",
  regions: ["asia"],
  iso2: "la",
  dialCode: "+856",
  hasAreaCodes: !1
}, {
  name: "Latvia (Latvija)",
  regions: ["europe", "european-union", "ex-ussr"],
  iso2: "lv",
  dialCode: "+371",
  hasAreaCodes: !1
}, {
  name: "Lebanon (‫لبنان‬‎)",
  regions: ["middle-east"],
  iso2: "lb",
  dialCode: "+961",
  hasAreaCodes: !1
}, {
  name: "Lesotho",
  regions: ["africa"],
  iso2: "ls",
  dialCode: "+266",
  hasAreaCodes: !1
}, {
  name: "Liberia",
  regions: ["africa"],
  iso2: "lr",
  dialCode: "+231",
  hasAreaCodes: !1
}, {
  name: "Libya (‫ليبيا‬‎)",
  regions: ["africa", "north-africa"],
  iso2: "ly",
  dialCode: "+218",
  hasAreaCodes: !1
}, {
  name: "Liechtenstein",
  regions: ["europe"],
  iso2: "li",
  dialCode: "+423",
  hasAreaCodes: !1
}, {
  name: "Lithuania (Lietuva)",
  regions: ["europe", "european-union", "ex-ussr"],
  iso2: "lt",
  dialCode: "+370",
  hasAreaCodes: !1
}, {
  name: "Luxembourg",
  regions: ["europe", "european-union"],
  iso2: "lu",
  dialCode: "+352",
  hasAreaCodes: !1
}, {
  name: "Macau (澳門)",
  regions: ["asia"],
  iso2: "mo",
  dialCode: "+853",
  hasAreaCodes: !1
}, {
  name: "Macedonia (FYROM) (Македонија)",
  regions: ["europe"],
  iso2: "mk",
  dialCode: "+389",
  hasAreaCodes: !1
}, {
  name: "Madagascar (Madagasikara)",
  regions: ["africa"],
  iso2: "mg",
  dialCode: "+261",
  hasAreaCodes: !1
}, {
  name: "Malawi",
  regions: ["africa"],
  iso2: "mw",
  dialCode: "+265",
  hasAreaCodes: !1
}, {
  name: "Malaysia",
  regions: ["asia"],
  iso2: "my",
  dialCode: "+60",
  hasAreaCodes: !1
}, {
  name: "Maldives",
  regions: ["asia"],
  iso2: "mv",
  dialCode: "+960",
  hasAreaCodes: !1
}, {
  name: "Mali",
  regions: ["africa"],
  iso2: "ml",
  dialCode: "+223",
  hasAreaCodes: !1
}, {
  name: "Malta",
  regions: ["europe", "european-union"],
  iso2: "mt",
  dialCode: "+356",
  hasAreaCodes: !1
}, {
  name: "Marshall Islands",
  regions: ["oceania"],
  iso2: "mh",
  dialCode: "+692",
  hasAreaCodes: !1
}, {
  name: "Martinique",
  regions: ["america", "carribean"],
  iso2: "mq",
  dialCode: "+596",
  hasAreaCodes: !1
}, {
  name: "Mauritania (‫موريتانيا‬‎)",
  regions: ["africa"],
  iso2: "mr",
  dialCode: "+222",
  hasAreaCodes: !1
}, {
  name: "Mauritius (Moris)",
  regions: ["africa"],
  iso2: "mu",
  dialCode: "+230",
  hasAreaCodes: !1
}, {
  name: "Mexico (México)",
  regions: ["america", "central-america"],
  iso2: "mx",
  dialCode: "+52",
  hasAreaCodes: !1
}, {
  name: "Micronesia",
  regions: ["oceania"],
  iso2: "fm",
  dialCode: "+691",
  hasAreaCodes: !1
}, {
  name: "Moldova (Republica Moldova)",
  regions: ["europe"],
  iso2: "md",
  dialCode: "+373",
  hasAreaCodes: !1
}, {
  name: "Monaco",
  regions: ["europe"],
  iso2: "mc",
  dialCode: "+377",
  hasAreaCodes: !1
}, {
  name: "Mongolia (Монгол)",
  regions: ["asia"],
  iso2: "mn",
  dialCode: "+976",
  hasAreaCodes: !1
}, {
  name: "Montenegro (Crna Gora)",
  regions: ["europe"],
  iso2: "me",
  dialCode: "+382",
  hasAreaCodes: !1
}, {
  name: "Montserrat",
  regions: ["america", "carribean"],
  iso2: "ms",
  dialCode: "+1664",
  hasAreaCodes: !1
}, {
  name: "Morocco (‫المغرب‬‎)",
  regions: ["africa", "north-africa"],
  iso2: "ma",
  dialCode: "+212",
  hasAreaCodes: !1
}, {
  name: "Mozambique (Moçambique)",
  regions: ["africa"],
  iso2: "mz",
  dialCode: "+258",
  hasAreaCodes: !1
}, {
  name: "Myanmar (Burma) (မြန်မာ)",
  regions: ["asia"],
  iso2: "mm",
  dialCode: "+95",
  hasAreaCodes: !1
}, {
  name: "Namibia (Namibië)",
  regions: ["africa"],
  iso2: "na",
  dialCode: "+264",
  hasAreaCodes: !1
}, {
  name: "Nauru",
  regions: ["africa"],
  iso2: "nr",
  dialCode: "+674",
  hasAreaCodes: !1
}, {
  name: "Nepal (नेपाल)",
  regions: ["asia"],
  iso2: "np",
  dialCode: "+977",
  hasAreaCodes: !1
}, {
  name: "Netherlands (Nederland)",
  regions: ["europe", "european-union"],
  iso2: "nl",
  dialCode: "+31",
  hasAreaCodes: !1
}, {
  name: "New Caledonia (Nouvelle-Calédonie)",
  regions: ["oceania"],
  iso2: "nc",
  dialCode: "+687",
  hasAreaCodes: !1
}, {
  name: "New Zealand",
  regions: ["oceania"],
  iso2: "nz",
  dialCode: "+64",
  hasAreaCodes: !1
}, {
  name: "Nicaragua",
  regions: ["america", "central-america"],
  iso2: "ni",
  dialCode: "+505",
  hasAreaCodes: !1
}, {
  name: "Niger (Nijar)",
  regions: ["africa"],
  iso2: "ne",
  dialCode: "+227",
  hasAreaCodes: !1
}, {
  name: "Nigeria",
  regions: ["africa"],
  iso2: "ng",
  dialCode: "+234",
  hasAreaCodes: !1
}, {
  name: "Niue",
  regions: ["asia"],
  iso2: "nu",
  dialCode: "+683",
  hasAreaCodes: !1
}, {
  name: "Norfolk Island",
  regions: ["oceania"],
  iso2: "nf",
  dialCode: "+672",
  hasAreaCodes: !1
}, {
  name: "North Korea (조선 민주주의 인민 공화국)",
  regions: ["asia"],
  iso2: "kp",
  dialCode: "+850",
  hasAreaCodes: !1
}, {
  name: "Northern Mariana Islands",
  regions: ["oceania"],
  iso2: "mp",
  dialCode: "+1670",
  hasAreaCodes: !1
}, {
  name: "Norway (Norge)",
  regions: ["europe"],
  iso2: "no",
  dialCode: "+47",
  hasAreaCodes: !1
}, {
  name: "Oman (‫عُمان‬‎)",
  regions: ["middle-east"],
  iso2: "om",
  dialCode: "+968",
  hasAreaCodes: !1
}, {
  name: "Pakistan (‫پاکستان‬‎)",
  regions: ["asia"],
  iso2: "pk",
  dialCode: "+92",
  hasAreaCodes: !1
}, {
  name: "Palau",
  regions: ["oceania"],
  iso2: "pw",
  dialCode: "+680",
  hasAreaCodes: !1
}, {
  name: "Palestine (‫فلسطين‬‎)",
  regions: ["middle-east"],
  iso2: "ps",
  dialCode: "+970",
  hasAreaCodes: !1
}, {
  name: "Panama (Panamá)",
  regions: ["america", "central-america"],
  iso2: "pa",
  dialCode: "+507",
  hasAreaCodes: !1
}, {
  name: "Papua New Guinea",
  regions: ["oceania"],
  iso2: "pg",
  dialCode: "+675",
  hasAreaCodes: !1
}, {
  name: "Paraguay",
  regions: ["america", "south-america"],
  iso2: "py",
  dialCode: "+595",
  hasAreaCodes: !1
}, {
  name: "Peru (Perú)",
  regions: ["america", "south-america"],
  iso2: "pe",
  dialCode: "+51",
  hasAreaCodes: !1
}, {
  name: "Philippines",
  regions: ["asia"],
  iso2: "ph",
  dialCode: "+63",
  hasAreaCodes: !1
}, {
  name: "Poland (Polska)",
  regions: ["europe", "european-union"],
  iso2: "pl",
  dialCode: "+48",
  hasAreaCodes: !1
}, {
  name: "Portugal",
  regions: ["europe", "european-union"],
  iso2: "pt",
  dialCode: "+351",
  hasAreaCodes: !1
}, {
  name: "Puerto Rico",
  regions: ["america", "carribean"],
  iso2: "pr",
  dialCode: "+1",
  hasAreaCodes: !0
}, {
  name: "Puerto Rico",
  regions: ["america", "carribean"],
  iso2: "pr",
  dialCode: "+1787",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Puerto Rico",
  regions: ["america", "carribean"],
  iso2: "pr",
  dialCode: "+1939",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Qatar (‫قطر‬‎)",
  regions: ["middle-east"],
  iso2: "qa",
  dialCode: "+974",
  hasAreaCodes: !1
}, {
  name: "Réunion (La Réunion)",
  regions: ["africa"],
  iso2: "re",
  dialCode: "+262",
  hasAreaCodes: !1
}, {
  name: "Romania (România)",
  regions: ["europe", "european-union"],
  iso2: "ro",
  dialCode: "+40",
  hasAreaCodes: !1
}, {
  name: "Russia (Россия)",
  regions: ["europe", "asia", "ex-ussr"],
  iso2: "ru",
  dialCode: "+7",
  hasAreaCodes: !1
}, {
  name: "Rwanda",
  regions: ["africa"],
  iso2: "rw",
  dialCode: "+250",
  hasAreaCodes: !1
}, {
  name: "Saint Barthélemy (Saint-Barthélemy)",
  regions: ["america", "carribean"],
  iso2: "bl",
  dialCode: "+590",
  hasAreaCodes: !1
}, {
  name: "Saint Helena",
  regions: ["africa"],
  iso2: "sh",
  dialCode: "+290",
  hasAreaCodes: !1
}, {
  name: "Saint Kitts and Nevis",
  regions: ["america", "carribean"],
  iso2: "kn",
  dialCode: "+1869",
  hasAreaCodes: !1
}, {
  name: "Saint Lucia",
  regions: ["america", "carribean"],
  iso2: "lc",
  dialCode: "+1758",
  hasAreaCodes: !1
}, {
  name: "Saint Martin (Saint-Martin (partie française))",
  regions: ["america", "carribean"],
  iso2: "mf",
  dialCode: "+590",
  hasAreaCodes: !1
}, {
  name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
  regions: ["america", "north-america"],
  iso2: "pm",
  dialCode: "+508",
  hasAreaCodes: !1
}, {
  name: "Saint Vincent and the Grenadines",
  regions: ["america", "carribean"],
  iso2: "vc",
  dialCode: "+1784",
  hasAreaCodes: !1
}, {
  name: "Samoa",
  regions: ["oceania"],
  iso2: "ws",
  dialCode: "+685",
  hasAreaCodes: !1
}, {
  name: "San Marino",
  regions: ["europe"],
  iso2: "sm",
  dialCode: "+378",
  hasAreaCodes: !1
}, {
  name: "São Tomé and Príncipe (São Tomé e Príncipe)",
  regions: ["africa"],
  iso2: "st",
  dialCode: "+239",
  hasAreaCodes: !1
}, {
  name: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
  regions: ["middle-east"],
  iso2: "sa",
  dialCode: "+966",
  hasAreaCodes: !1
}, {
  name: "Senegal (Sénégal)",
  regions: ["africa"],
  iso2: "sn",
  dialCode: "+221",
  hasAreaCodes: !1
}, {
  name: "Serbia (Србија)",
  regions: ["europe"],
  iso2: "rs",
  dialCode: "+381",
  hasAreaCodes: !1
}, {
  name: "Seychelles",
  regions: ["africa"],
  iso2: "sc",
  dialCode: "+248",
  hasAreaCodes: !1
}, {
  name: "Sierra Leone",
  regions: ["africa"],
  iso2: "sl",
  dialCode: "+232",
  hasAreaCodes: !1
}, {
  name: "Singapore",
  regions: ["asia"],
  iso2: "sg",
  dialCode: "+65",
  hasAreaCodes: !1
}, {
  name: "Sint Maarten",
  regions: ["america", "carribean"],
  iso2: "sx",
  dialCode: "+1721",
  hasAreaCodes: !1
}, {
  name: "Slovakia (Slovensko)",
  regions: ["europe", "european-union"],
  iso2: "sk",
  dialCode: "+421",
  hasAreaCodes: !1
}, {
  name: "Slovenia (Slovenija)",
  regions: ["europe", "european-union"],
  iso2: "si",
  dialCode: "+386",
  hasAreaCodes: !1
}, {
  name: "Solomon Islands",
  regions: ["oceania"],
  iso2: "sb",
  dialCode: "+677",
  hasAreaCodes: !1
}, {
  name: "Somalia (Soomaaliya)",
  regions: ["africa"],
  iso2: "so",
  dialCode: "+252",
  hasAreaCodes: !1
}, {
  name: "South Africa",
  regions: ["africa"],
  iso2: "za",
  dialCode: "+27",
  hasAreaCodes: !1
}, {
  name: "South Korea (대한민국)",
  regions: ["asia"],
  iso2: "kr",
  dialCode: "+82",
  hasAreaCodes: !1
}, {
  name: "South Sudan (‫جنوب السودان‬‎)",
  regions: ["africa", "north-africa"],
  iso2: "ss",
  dialCode: "+211",
  hasAreaCodes: !1
}, {
  name: "Spain (España)",
  regions: ["europe", "european-union"],
  iso2: "es",
  dialCode: "+34",
  hasAreaCodes: !1
}, {
  name: "Sri Lanka (ශ්‍රී ලංකාව)",
  regions: ["asia"],
  iso2: "lk",
  dialCode: "+94",
  hasAreaCodes: !1
}, {
  name: "Sudan (‫السودان‬‎)",
  regions: ["africa"],
  iso2: "sd",
  dialCode: "+249",
  hasAreaCodes: !1
}, {
  name: "Suriname",
  regions: ["america", "south-america"],
  iso2: "sr",
  dialCode: "+597",
  hasAreaCodes: !1
}, {
  name: "Swaziland",
  regions: ["africa"],
  iso2: "sz",
  dialCode: "+268",
  hasAreaCodes: !1
}, {
  name: "Sweden (Sverige)",
  regions: ["europe", "european-union"],
  iso2: "se",
  dialCode: "+46",
  hasAreaCodes: !1
}, {
  name: "Switzerland (Schweiz)",
  regions: ["europe"],
  iso2: "ch",
  dialCode: "+41",
  hasAreaCodes: !1
}, {
  name: "Syria (‫سوريا‬‎)",
  regions: ["middle-east"],
  iso2: "sy",
  dialCode: "+963",
  hasAreaCodes: !1
}, {
  name: "Taiwan (台灣)",
  regions: ["asia"],
  iso2: "tw",
  dialCode: "+886",
  hasAreaCodes: !1
}, {
  name: "Tajikistan",
  regions: ["asia", "ex-ussr"],
  iso2: "tj",
  dialCode: "+992",
  hasAreaCodes: !1
}, {
  name: "Tanzania",
  regions: ["africa"],
  iso2: "tz",
  dialCode: "+255",
  hasAreaCodes: !1
}, {
  name: "Thailand (ไทย)",
  regions: ["asia"],
  iso2: "th",
  dialCode: "+66",
  hasAreaCodes: !1
}, {
  name: "Timor-Leste",
  regions: ["asia"],
  iso2: "tl",
  dialCode: "+670",
  hasAreaCodes: !1
}, {
  name: "Togo",
  regions: ["africa"],
  iso2: "tg",
  dialCode: "+228",
  hasAreaCodes: !1
}, {
  name: "Tokelau",
  regions: ["oceania"],
  iso2: "tk",
  dialCode: "+690",
  hasAreaCodes: !1
}, {
  name: "Tonga",
  regions: ["oceania"],
  iso2: "to",
  dialCode: "+676",
  hasAreaCodes: !1
}, {
  name: "Trinidad and Tobago",
  regions: ["america", "carribean"],
  iso2: "tt",
  dialCode: "+1868",
  hasAreaCodes: !1
}, {
  name: "Tunisia (‫تونس‬‎)",
  regions: ["africa", "north-africa"],
  iso2: "tn",
  dialCode: "+216",
  hasAreaCodes: !1
}, {
  name: "Turkey (Türkiye)",
  regions: ["europe"],
  iso2: "tr",
  dialCode: "+90",
  hasAreaCodes: !1
}, {
  name: "Turkmenistan",
  regions: ["asia", "ex-ussr"],
  iso2: "tm",
  dialCode: "+993",
  hasAreaCodes: !1
}, {
  name: "Turks and Caicos Islands",
  regions: ["america", "carribean"],
  iso2: "tc",
  dialCode: "+1649",
  hasAreaCodes: !1
}, {
  name: "Tuvalu",
  regions: ["asia"],
  iso2: "tv",
  dialCode: "+688",
  hasAreaCodes: !1
}, {
  name: "U.S. Virgin Islands",
  regions: ["america", "carribean"],
  iso2: "vi",
  dialCode: "+1340",
  hasAreaCodes: !1
}, {
  name: "Uganda",
  regions: ["africa"],
  iso2: "ug",
  dialCode: "+256",
  hasAreaCodes: !1
}, {
  name: "Ukraine",
  regions: ["europe", "ex-ussr"],
  iso2: "ua",
  dialCode: "+380",
  hasAreaCodes: !1
}, {
  name: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
  regions: ["middle-east"],
  iso2: "ae",
  dialCode: "+971",
  hasAreaCodes: !1
}, {
  name: "United Kingdom",
  regions: ["europe", "european-union"],
  iso2: "gb",
  dialCode: "+44",
  hasAreaCodes: !1
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1",
  hasAreaCodes: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1907",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1205",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1251",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1256",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1334",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1479",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1501",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1870",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1480",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1520",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1602",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1623",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1928",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1209",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1213",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1310",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1323",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1408",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1415",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1510",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1530",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1559",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1562",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1619",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1626",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1650",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1661",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1707",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1714",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1760",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1805",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1818",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1831",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1858",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1909",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1916",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1925",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1949",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1951",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1303",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1719",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1970",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1203",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1860",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1202",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1302",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1239",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1305",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1321",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1352",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1386",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1407",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1561",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1727",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1772",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1813",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1850",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1863",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1904",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1941",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1954",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1229",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1404",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1478",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1706",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1770",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1912",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1808",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1319",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1515",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1563",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1641",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1712",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1208",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1217",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1309",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1312",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1618",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1630",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1708",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1773",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1815",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1847",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1219",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1260",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1317",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1574",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1765",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1812",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1316",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1620",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1785",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1913",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1270",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1502",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1606",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1859",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1225",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1318",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1337",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1504",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1985",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1413",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1508",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1617",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1781",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1978",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1301",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1410",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1207",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1231",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1248",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1269",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1313",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1517",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1586",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1616",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1734",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1810",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1906",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1989",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1218",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1320",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1507",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1612",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1651",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1763",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1952",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1314",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1417",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1573",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1636",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1660",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1816",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1228",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1601",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1662",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1406",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1252",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1336",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1704",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1828",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1910",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1919",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1701",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1308",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1402",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1603",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1201",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1609",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1732",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1856",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1908",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1973",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1505",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1575",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1702",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1775",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1212",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1315",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1516",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1518",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1585",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1607",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1631",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1716",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1718",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1845",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1914",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1216",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1330",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1419",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1440",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1513",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1614",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1740",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1937",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1405",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1580",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1918",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1503",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1541",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1215",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1412",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1570",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1610",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1717",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1724",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1814",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1401",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1803",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1843",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1864",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1605",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1423",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1615",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1731",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1865",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1901",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1931",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1210",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1214",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1254",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1281",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1325",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1361",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1409",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1432",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1512",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1713",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1806",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1817",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1830",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1903",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1915",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1936",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1940",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1956",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1972",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1979",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1435",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1801",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1276",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1434",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1540",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1703",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1757",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1804",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1802",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1206",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1253",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1360",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1425",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1509",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1262",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1414",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1608",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1715",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1920",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1304",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "United States",
  regions: ["america", "north-america"],
  iso2: "us",
  dialCode: "+1307",
  hasAreaCodes: !0,
  isAreaCode: !0
}, {
  name: "Uruguay",
  regions: ["america", "south-america"],
  iso2: "uy",
  dialCode: "+598",
  hasAreaCodes: !1
}, {
  name: "Uzbekistan (Oʻzbekiston)",
  regions: ["asia", "ex-ussr"],
  iso2: "uz",
  dialCode: "+998",
  hasAreaCodes: !1
}, {
  name: "Vanuatu",
  regions: ["oceania"],
  iso2: "vu",
  dialCode: "+678",
  hasAreaCodes: !1
}, {
  name: "Vatican City (Città del Vaticano)",
  regions: ["europe"],
  iso2: "va",
  dialCode: "+39",
  hasAreaCodes: !1
}, {
  name: "Venezuela",
  regions: ["america", "south-america"],
  iso2: "ve",
  dialCode: "+58",
  hasAreaCodes: !1
}, {
  name: "Vietnam (Việt Nam)",
  regions: ["asia"],
  iso2: "vn",
  dialCode: "+84",
  hasAreaCodes: !1
}, {
  name: "Wallis and Futuna",
  regions: ["oceania"],
  iso2: "wf",
  dialCode: "+681",
  hasAreaCodes: !1
}, {
  name: "Yemen (‫اليمن‬‎)",
  regions: ["middle-east"],
  iso2: "ye",
  dialCode: "+967",
  hasAreaCodes: !1
}, {
  name: "Zambia",
  regions: ["africa"],
  iso2: "zm",
  dialCode: "+260",
  hasAreaCodes: !1
}, {
  name: "Zimbabwe",
  regions: ["africa"],
  iso2: "zw",
  dialCode: "+263",
  hasAreaCodes: !1
}],
    U = function U(e, a) {
  return g.find(function (i) {
    return i[e] === a;
  });
},
    p = function p(e) {
  var a = e.startsWith("+") ? e.slice(1, 6) : e.slice(0, 5);
  return g.find(function (e) {
    return e.dialCode.startsWith("+".concat(a.replace(" ", "")));
  });
},
    S = function S(e) {
  return "string" == typeof e ? g.filter(function (a) {
    return a.regions.includes(e.toLowerCase());
  }) : g.filter(function (a) {
    return e.map(function (e) {
      return a.regions.includes(e.toLowerCase());
    }).some(function (e) {
      return e;
    });
  });
},
    b = function b(e, a, i) {
  return e ? U("iso2", e.toLowerCase()) : a.length ? U("iso2", a[0].toLowerCase()) : i ? S(i)[0] : U("iso2", "intl");
},
    Q = function Q(e, a) {
  return e.length ? function (e) {
    return e.map(function (e) {
      return U("iso2", e.toLowerCase());
    });
  }(e) : a ? S(a) : g;
},
    f = function f(e, a, i) {
  var s = e;
  "INTERNATIONAL" === a && (s.startsWith("+") || (s = "+".concat(s)), s.startsWith("+00") && (s = s.replace("00", "")));
  var o = C(s, i.toUpperCase());

  try {
    s = o.format(a);
  } catch (e) {
    s = s.replace(/\(+-()\)/g, "");
  }

  return s;
};

!function (e, a) {
  void 0 === a && (a = {});
  var i = a.insertAt;

  if (e && "undefined" != typeof document) {
    var s = document.head || document.getElementsByTagName("head")[0],
        o = document.createElement("style");
    o.type = "text/css", "top" === i && s.firstChild ? s.insertBefore(o, s.firstChild) : s.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}('.react-phonenr-input{display:flex;max-width:320px;position:relative}.react-phonenr-input button,.react-phonenr-input input{appearance:none;-moz-appearance:none;-webkit-appearance:none;box-sizing:border-box;border:1px solid #ccc;outline:none;border-radius:0;height:1.8rem}.react-phonenr-input .flag-wrapper{position:relative;display:flex;align-content:center;justify-content:center;align-items:center;padding-right:7px;padding-left:2px;width:30px;border:1px solid #ccc;border-right:none;background-color:#ddd}.react-phonenr-input .flag-wrapper img{width:20px;position:absolute;top:50%;transform:translateY(-50%);z-index:5}.react-phonenr-input .flag-wrapper select{position:absolute;appearance:none;-moz-appearance:none;-webkit-appearance:none;width:100%;height:100%;padding:0;margin:0;border:none;border-radius:0;opacity:0;z-index:10}.react-phonenr-input .flag-wrapper:after{content:"";width:0;height:0;border:2.8px solid transparent;border-top-color:#000;position:absolute;right:2px;top:50%;transform:translateY(-50%);pointer-events:none}.react-phonenr-input input{width:280px;font-size:inherit;padding:0 5px}.react-phonenr-input ul{box-sizing:border-box;width:100%;max-height:290px;position:absolute;top:35px;border:1px solid #ccc;list-style:none;margin:0;overflow-y:auto;padding:0;background-color:#fff;z-index:999}.react-phonenr-input ul li{position:relative;display:flex;align-items:center;align-content:space-between;font-size:1rem;padding:3px .5rem 3px 35px}.react-phonenr-input ul li.active-country,.react-phonenr-input ul li:hover{background-color:#ddd;color:currentColor;cursor:pointer}.react-phonenr-input ul li span{position:absolute!important;top:50%!important;left:3px!important;transform:translateY(-50%)!important;margin:0 5px}.react-phonenr-input ul::-webkit-scrollbar{width:3px}.react-phonenr-input ul::-webkit-scrollbar-track{background:#f1f1f1;box-shadow:inset 0 0 5px #ccc}.react-phonenr-input ul::-webkit-scrollbar-thumb{background:#888}.react-phonenr-input ul::-webkit-scrollbar-thumb:hover{background:#555}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9saWIvY29tcG9uZW50cy9QaG9uZUlucHV0L3N0eWxlcy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLHFCQUNFLFlBQWEsQ0FDYixlQUFnQixDQUNoQixpQkFBa0IsQ0FIcEIsdURBTUksZUFBZ0IsQ0FDaEIsb0JBQXFCLENBQ3JCLHVCQUF3QixDQUN4QixxQkFBc0IsQ0FDdEIscUJBQXNCLENBQ3RCLFlBQWEsQ0FDYixlQUFrQixDQUNsQixhQUF3QixDQWI1QixtQ0FnQkksaUJBQWtCLENBQ2xCLFlBQWEsQ0FDYixvQkFBcUIsQ0FDckIsc0JBQXVCLENBQ3ZCLGtCQUFtQixDQUNuQixpQkFBa0IsQ0FDbEIsZ0JBQWlCLENBQ2pCLFVBQVcsQ0FFWCxxQkFBa0IsQ0FBbEIsaUJBQWtCLENBQ2xCLHFCQUFzQixDQTFCMUIsdUNBNEJNLFVBQVcsQ0FDWCxpQkFBa0IsQ0FDbEIsT0FBUSxDQUNSLDBCQUEyQixDQUMzQixTQUFVLENBaENoQiwwQ0FtQ00saUJBQWtCLENBQ2xCLGVBQWdCLENBQ2hCLG9CQUFxQixDQUNyQix1QkFBd0IsQ0FDeEIsVUFBVyxDQUNYLFdBQVksQ0FDWixTQUFVLENBQ1YsUUFBUyxDQUNULFdBQVksQ0FDWixlQUFrQixDQUNsQixTQUFVLENBQ1YsVUFBVyxDQTlDakIseUNBaURNLFVBQVcsQ0FDWCxPQUFRLENBQ1IsUUFBUyxDQUVULDhCQUFzRCxDQUF0RCxxQkFBc0QsQ0FDdEQsaUJBQWtCLENBQ2xCLFNBQVUsQ0FDVixPQUFRLENBQ1IsMEJBQTJCLENBQzNCLG1CQUFvQixDQTFEMUIsMkJBOERJLFdBQVksQ0FDWixpQkFBa0IsQ0FDbEIsYUFBZ0IsQ0FoRXBCLHdCQW1FSSxxQkFBc0IsQ0FDdEIsVUFBVyxDQUNYLGdCQUFpQixDQUNqQixpQkFBa0IsQ0FDbEIsUUFBUyxDQUNULHFCQUFzQixDQUN0QixlQUFnQixDQUNoQixRQUFTLENBQ1QsZUFBZ0IsQ0FDaEIsU0FBVSxDQUNWLHFCQUFzQixDQUN0QixXQXNDcUIsQ0FwSHpCLDJCQWdGTSxpQkFBa0IsQ0FDbEIsWUFBYSxDQUNiLGtCQUFtQixDQUNuQiwyQkFBNEIsQ0FDNUIsY0FBZSxDQUNmLDBCQUE0QixDQXJGbEMsMkVBd0ZRLHFCQUFzQixDQUN0QixrQkFBbUIsQ0FDbkIsY0FBZSxDQTFGdkIsZ0NBNkZRLDJCQUE2QixDQUM3QixpQkFBbUIsQ0FDbkIsa0JBQW9CLENBQ3BCLG9DQUFzQyxDQUN0QyxZQUFlLENBakd2QiwyQ0FzR00sU0FBVSxDQXRHaEIsaURBMkdNLGtCQUFtQixDQUNuQiw2QkFBOEIsQ0E1R3BDLGlEQWlITSxlQUFnQixDQWpIdEIsdURBc0hNLGVBQWdCIiwiZmlsZSI6InN0eWxlcy5zY3NzIn0= */');

var x = function x(a) {
  var C = a.className,
      m = a.defaultCountry,
      c = a.preferredCountries,
      l = a.regions,
      g = a.format,
      S = a.initialValue,
      x = a.withCountryMeta,
      N = a.onChange,
      B = a.disabled,
      k = a.buttonFlagStyles,
      F = a.listFlagStyles,
      y = a.placeholder,
      I = h(i(b(m, c, l)), 2),
      E = I[0],
      w = I[1],
      L = h(i("INTERNATIONAL" === g ? b(m, c, l).dialCode : ""), 2),
      D = L[0],
      v = L[1],
      z = h(i(!1), 2),
      M = z[0],
      T = z[1],
      R = s(null),
      V = s(null),
      O = s(null),
      G = s(null),
      P = u.any(),
      J = E.iso2,
      j = function j(e) {
    R.current && !R.current.contains(e.target) && T(!1);
  };

  o(function () {
    var e,
        a = x ? {
      phoneNumber: D,
      country: t(E, ["hasAreaCodes", "isAreaCode", "dialCode", "regions"])
    } : D;
    M && J && "intl" !== J && (O.current.scrollTop = (null === (e = G.current) || void 0 === e ? void 0 : e.offsetTop) - 50);
    N(a);
  }, [E, D, M]), o(function () {
    if (document.addEventListener("mousedown", j), S) {
      var e = S.startsWith("+") ? S.slice(1, 4) : S.slice(0, 3);
      w(function (a) {
        return "INTERNATIONAL" === g && p(e) ? p(e) : a;
      }), v(f(S, g, J));
    }

    return function () {
      document.removeEventListener("mousedown", j);
    };
  }, []);
  var W = r(function (e) {
    return function (a) {
      var i = U("iso2", e || a.target.value);
      w(i), v(i.dialCode), T(!1), V.current.focus();
    };
  }, [E]),
      Y = r(function () {
    B || T(function (e) {
      return !e;
    });
  }, [M]);
  return e.createElement("div", {
    className: "react-phonenr-input",
    ref: R
  }, "INTERNATIONAL" === g && e.createElement("div", {
    onClick: P ? void 0 : Y,
    className: "flag-wrapper",
    role: "none"
  }, "intl" === J ? e.createElement("img", {
    src: "data:image/png;base64,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",
    alt: "globe"
  }) : e.createElement(d, {
    code: J || "",
    styleProps: A({
      display: "block",
      position: "absolute",
      width: "20px",
      height: "15px",
      backgroundPosition: "center center",
      zIndex: 7
    }, k),
    svg: !0
  }), P && e.createElement("select", {
    className: C,
    onChange: W(),
    disabled: B
  }, Q(c, l).map(function (a) {
    return a.isAreaCode ? null : e.createElement("option", {
      key: a.iso2,
      value: a.iso2
    }, a.name);
  }))), e.createElement("input", {
    className: C,
    type: "tel",
    value: D,
    onChange: function onChange(e) {
      var a = e.target.value,
          i = p(a);
      if (!a.length) return w(b(m, c, l)), void v("");
      /^[\d ()+-]+$/.test(a) && (w(function (e) {
        return "INTERNATIONAL" === g && i ? i : e;
      }), v(f(a, g, J)));
    },
    placeholder: y,
    disabled: B,
    ref: V,
    maxLength: "21"
  }), M && "INTERNATIONAL" === g && !P && e.createElement("ul", {
    className: "country-list",
    ref: O
  }, Q(c, l).map(function (a) {
    return a.isAreaCode ? null : e.createElement("li", {
      key: a.iso2,
      onClick: W(a.iso2),
      onKeyPress: W(a.iso2),
      className: n("country-list-item", {
        "active-country": a.iso2 === J
      }),
      ref: a.iso2 === J ? G : null
    }, e.createElement(d, {
      styleProps: A({
        width: "20px"
      }, F),
      code: a.iso2,
      svg: !0
    }), " ".concat(a.name));
  })));
};

x.defaultProps = {
  defaultCountry: null,
  preferredCountries: [],
  regions: null,
  format: "INTERNATIONAL",
  placeholder: "+1 702 123 4567",
  className: null,
  disabled: !1,
  withCountryMeta: !1,
  buttonFlagStyles: null,
  listFlagStyles: null,
  initialValue: null
};
var N = a(x);
export { N as PhoneInput };